import React from 'react'
import '../App.css';
import ScrambledText from '../Reactbits/ScrambledText/ScrambledText';
function SecParagraph({data}) {
  return (
    <div className='secpara'>

      <p>
      <ScrambledText
  className="scrambled-text-demo"
 
>
      {data}
      </ScrambledText>
      </p>
      
    </div>
  )
}

export default SecParagraph
